import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectIsNotLastFloorFilter } from 'shared/selectors/advancedFilters';

export const IsNotLastFloorContainer = () => {
  const { label, value } = useSelector(selectIsNotLastFloorFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setNotLastFloor', arguments: [newValue || null] });
    },
    [onChange],
  );

  return (
    <InlineFilter>
      <Checkbox label={label} checked={value} onChange={handleChange} />
    </InlineFilter>
  );
};
